import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
  SecurityContext,
} from "@angular/core";
import {
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
} from "@angular/router";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { MAT_CARD_CONFIG } from "@angular/material/card";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from "@angular/material/slide-toggle";
import { provideQuillConfig } from "ngx-quill";
import { routes } from "./app.routes";
import { errorInterceptor } from "./interceptors/error.interceptor";
import { jwtInterceptor } from "./interceptors/jwt.interceptor";
import { refreshTokenInterceptor } from "./interceptors/refresh-token.interceptor";
import { DatePipe } from "@angular/common";
import { provideAnimations } from "@angular/platform-browser/animations";
import { AppErrorHandler } from "./app.error-handler";
import { provideMarkdown } from "ngx-markdown";
// `quill` is loaded via the `scripts` entry in angular.json. Use the global instead
declare const Quill: any;
const icons: any = ((window as any).Quill || Quill).import("ui/icons");

icons["bold"] =
  '<span class="quill material-symbols-outlined">format_bold</span>';
icons["italic"] =
  '<span class="quill material-symbols-outlined">format_italic</span>';
icons["underline"] =
  '<span class="quill material-symbols-outlined">format_underlined</span>';
icons["strike"] =
  '<span class="quill material-symbols-outlined">strikethrough_s</span>';

icons["link"] = '<span class="quill material-symbols-outlined">link</span>';
icons["image"] = '<span class="quill material-symbols-outlined">image</span>';
icons["video"] =
  '<span class="quill material-symbols-outlined">video_library</span>';

icons["color"] =
  '<span class="quill material-symbols-outlined">format_color_text</span>';
icons["background"] =
  '<span class="quill material-symbols-outlined">format_color_fill</span>';

icons["list"] = {
  bullet:
    '<span class="quill material-symbols-outlined">format_list_bulleted</span>',
  ordered:
    '<span class="quill material-symbols-outlined">format_list_numbered</span>',
};

icons["script"] = {
  sub: '<span class="quill material-symbols-outlined">subscript</span>',
  super: '<span class="quill material-symbols-outlined">superscript</span>',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideNativeDateAdapter(),
    provideMarkdown({}),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: "enabled" }),
      withRouterConfig({ onSameUrlNavigation: "reload" }),
    ),
    provideHttpClient(
      withInterceptors([
        jwtInterceptor,
        refreshTokenInterceptor,
        errorInterceptor,
      ]),
    ),
    provideQuillConfig({}),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "outline" },
    },
    {
      provide: MAT_CARD_CONFIG,
      useValue: { appearance: "outlined" },
    },
    {
      provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
      useValue: { hideIcon: true },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { maxWidth: "650px", width: "100%", disableClose: true },
    },
    DatePipe,
    { provide: ErrorHandler, useClass: AppErrorHandler },
  ],
};
